export default __webpack_public_path__ + "static/media/dTT.2891e975.png";